var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tame-discrete-color-legend"},[_c('div',{ref:"svgContainer"}),(_vm.variable.domain.length > _vm.maxCount)?_c('div',{staticClass:"subheading ml-3 mb-0"},[_vm._v(" ... and "+_vm._s((_vm.variable.domain.length - 10).toLocaleString())+" more ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }